import useStorageDownload from "./useStorageDownload";
import useStorageUpload from "./useStorageUpload";

const utilities = {
    useStorageUpload,
    useStorageDownload,
}

export default utilities